export default __webpack_public_path__ + "static/media/risk-on.1df02b55.svg";